import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import CriarQuestionario from "./pages/CriarQuestionario";
import Questionarios from "./pages/Questionarios";
import Questionario from "./pages/Questionario";
import "survey-core/survey.i18n";
import QuestionarioRead from "./pages/QuestionarioRead";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      /* {
        path: "/",
        element: <Home />,
      }, */
      {
        path: "criar-questionario",
        element: <CriarQuestionario />,
      },
      {
        path: "/questionarios/:questionarioPack", //"questionarios",
        element: <Questionarios />,
      },
      {
        path: "/:questionarioName", //"questionarios/:questionarioName",
        element: <Questionario />,
      },
      {
        path: "/:questionarioName/ler", //"questionarios/:questionarioName/ler",
        element: <QuestionarioRead />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
